import { render, staticRenderFns } from "./detailed-statement.vue?vue&type=template&id=5d088796&scoped=true&"
import script from "./detailed-statement.vue?vue&type=script&lang=js&"
export * from "./detailed-statement.vue?vue&type=script&lang=js&"
import style0 from "./detailed-statement.vue?vue&type=style&index=0&id=5d088796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d088796",
  null
  
)

export default component.exports